"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginContainer = void 0;
var React = require("react");
var classnames = require("classnames");
var LoadingView_1 = require("../../views/LoadingView");
var Logo_1 = require("./Logo");
var Avatar_1 = require("./Avatar");
var components_1 = require("components");
var MaintaenanceBanner_1 = require("components/MaintaenanceBanner");
require("./styles.scss");
var LoginContainer = function (props) { return (React.createElement("div", { className: classnames('login-container', props.className) },
    React.createElement(MaintaenanceBanner_1.default, null),
    props.translations.status === 'FETCHED' && (React.createElement("div", { className: 'login-wrapper' },
        React.createElement(Logo_1.default, null),
        React.createElement(Avatar_1.default, null),
        props.children,
        React.createElement(components_1.InfoTexts, null),
        React.createElement(components_1.Copyrights, null))),
    props.translations.status === 'FETCHED' && (React.createElement("div", { className: classnames('login-background animated fadeIn', props.sso ? 'sso' : "bg-".concat(props.bg)) })),
    props.translations.status !== 'FETCHED' && (React.createElement(LoadingView_1.default, { translations: props.translations })))); };
exports.LoginContainer = LoginContainer;
exports.default = exports.LoginContainer;
